import { render } from "./MultiselectableDropdown.vue?vue&type=template&id=4bbf894b"
import script from "./MultiselectableDropdown.vue?vue&type=script&lang=js"
export * from "./MultiselectableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__